<template>
  <div class="body">
    <div class="opportunity">本月你还有{{ prizeNums }}次抽奖机会</div>
    <div class="LuckyWheel">
      <LuckyWheel ref="myLucky" width="370px" height="370px" :prizes="prizes" :blocks="blocks" :buttons="buttons"
        @start="startCallback" @end="endCallback" />
    </div>
    <div class="kh">卡号：{{ loginText }}</div>
    <div class="btnfx">
      <!-- <div class="lefx" @click="show=true">邀请新用户</div> -->
      <div class="lefx" @click="goPkg()">续费套餐</div>
      <div class="refx" @click="isShow = true">余额购买</div>
    </div>
    <div class="zjjl" @click="linkGto">中奖记录</div>
    <div class="msgz">
      <img src="@/assets/dzp/left.png" alt="" />
      规则描述
      <img src="@/assets/dzp/right.png" alt="" />
    </div>
    <div class="ysaf">
      <p>1：VIP用户每购买一次套餐 可格外获得一次抽奖次数</p>
      <p>2：可使用卡余额可购买抽奖次数</p>
      <p>3：仅限VIP用户参与，VIP到期或退款将无法参与</p>

    </div>
    <!--充值-->
    <div class="recharge" v-if="isShow">
      <div class="r-bg"></div>
      <div class="r-content">
        <div class="select">请选择套餐：</div>
        <van-row>
          <van-col span="8">
            <div class="colow" @click="changesss(6)" :class="[index === 6 ? 'active' : '']">
              <div class="price">6元</div>
              <div class="price-num">6次</div>
            </div>
          </van-col>
          <van-col span="8">
            <div class="colow" @click="changesss(20)" :class="[index === 20 ? 'active' : '']">
              <div class="price">15元</div>
              <div class="price-num">20次</div>
            </div>
          </van-col>
          <van-col span="8">
            <div class="colow" @click="changesss(30)" :class="[index === 30 ? 'active' : '']">
              <div class="price">20元</div>
              <div class="price-num">30次</div>
            </div>
          </van-col>
        </van-row>
        <van-button type="info" class="btnButton" @click="sunmbitFn()">马上订购</van-button>
        <div class="zbxf" @click="isShow = false">暂时不订购</div>
      </div>
    </div>
    <!--中奖-->
    <div class="recharge" v-if="zjShow">
      <div class="r-bg"></div>
      <div class="r-content-zj">
        <div class="title">{{ formData.text }}</div>
        <div class="sm-title">{{ formData.text }}</div>
        <div class="zj-img">
          <img :src="formData.imgUrl" alt="">
        </div>
        <van-button type="info" class="btnButton" @click="zjShow = false">继续抽奖</van-button>
        <div class="zbxf" @click="zjShow = false">取消</div>
      </div>
    </div>
    <!-- 密码框   -->
    <div class="van-overlay" style="z-index: 1999;" v-show="showPasswordPanel"></div>
    <div class="van-popup van-popup--round van-popup--center changePasswordPanel-balanceRecharge"
      style="z-index: 2000; min-height: 25%; min-width: 80%;" v-show="showPasswordPanel"
      :style="{ top: passwordPanelTop + '%' }">

      <van-icon name="cross" class="icon-cross" @click="cancelChangePassword()" />

      <!-- 密码输入框 -->
      <p>支付密码：</p>
      <van-password-input :value="password" />
      <div class="confirmChangePassword">
        <van-button class="confirmChangePasswordBtn" plain hairline type="info" @click="sureToRecharge()">确定</van-button>
      </div>

    </div>
    <van-number-keyboard :z-index="2015" :show="confirmPasswordKeyboard" @input="confirmPasswordOnInput"
      @delete="confirmPasswordOnDelete" @blur="confirmPasswordKeyboard = false" />

    <van-popup v-model="show" :round="true">
      <vue-qr :text="urls" id="urls_id" :size="300"></vue-qr>
      <van-button type="info" class="btnButton" @click="downloadIamge">保存二维码分享</van-button>
    </van-popup>

  </div>
</template>
<script>
import { Toast, Dialog } from "vant";
import { wxRequest } from "@/api/user.js";
import wx from 'weixin-js-sdk';
import { wexinShare } from '@/utils/weixin.js';
import VueQr from 'vue-qr';
export default {
  components: {
    VueQr
  },
  data() {
    return {
      show: false,
      blocks: [
        {
          padding: '34px',
          imgs: [{
            src: 'http://image.szxxtx.com:8888/group1/M00/01/2B/rBKyymK69aGALbfdAAUYod_t48M226.png',
            width: '120%',
            height: '120%',
            top: '-10%'
          }]
        },
        {
          padding: '10px',
          imgs: [{
            src: 'http://image.szxxtx.com:8888/group1/M00/01/2B/rBKyymK69YWAGAdFAAB_aSTQI5A402.png',
            width: '100%',
            height: '100%'
          }]
        },
        {
          imgs: [{
            src: 'http://image.szxxtx.com:8888/group1/M00/01/2B/rBKyymK69YWAGAdFAAB_aSTQI5A402.png',
            width: '100%',
            height: '100%'
          }]
        }
      ],
      prizes: [],
      buttons: [
        { radius: '50px', background: '#FFE3C1' },
        { radius: '45px', background: '#FFEAA2' },
        {
          radius: '45px',
          imgs: [{
            src: 'http://image.szxxtx.com:8888/group1/M00/01/2B/rBKyymK69VSAdodTAACkyMxQj_E694.png',
            width: '100%',
            top: '-130%'
          }],
          pointer: true,

        },
      ],
      loginText: localStorage.getItem("recordLoginText"),
      prizeNums: 0,
      password: '',
      showPasswordPanel: false,
      passwordPanelTop: 50,
      index: 6,
      formData: {},
      confirmPasswordKeyboard: false,
      isShow: false,
      zjShow: false,
      iccid: this.$store.state.iccid,
      urls: '',
      dataList: []
    }
  },
  created() {
    this.urls = window.location.href;
    this.init();
    //this.goshare1()

  },
  methods: {

    goPkg() {
      this.$router.push({
        path: '/user/recharge',
        query: {
          'iccid': this.$store.state.iccid
        }
      })
    },
    downloadIamge() {
      let downloadName = "移动100G流量免费领";
      let imgData = document.getElementById("urls_id").src;
      this.downloadFile(downloadName, imgData);
    },
    downloadFile(fileName, content) {
      let aLink = document.createElement('a')
      let blob = this.base64ToBlob(content) // new Blob([content]);
      let evt = document.createEvent('HTMLEvents')
      evt.initEvent('click', true, true)// initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
      aLink.download = fileName
      aLink.href = URL.createObjectURL(blob)
      // aLink.dispatchEvent(evt);
      aLink.click()
    },
    // base64转blob
    base64ToBlob(code) {
      let parts = code.split(';base64,')
      let contentType = parts[0].split(':')[1]
      let raw = window.atob(parts[1]) // 解码base64得到二进制字符串
      let rawLength = raw.length
      let uInt8Array = new Uint8Array(rawLength) // 创建8位无符号整数值的类型化数组
      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i) // 数组接收二进制字符串
      }
      return new Blob([uInt8Array], { type: contentType })
    },

    goshare1() {
      this.urls = 'http://webchat.szxxtx.com/#/user/applygdtdouyingMy';
      wxRequest("sim/getWxConfig3", {}, "get").then(res => {
        if (res.data.code == 200) {
          console.log("微信配置信息", res.data.data)
          let data = res.data.data;
          wx.config({
            debug: false,
            appId: data.appId,
            nonceStr: data.nonceStr,
            signature: data.signature,
            timestamp: parseInt(data.timestamp),
            jsApiList: ["onMenuShareAppMessage"]
          });
          wx.ready(() => {
            wx.onMenuShareAppMessage({
              title: "移动100G流量免费领！",
              desc: "点击此链接即可免费领取 包邮到家！",
              link: this.urls,
              imgUrl: "https://blogobs.88688.team/blog/l-logo-y.jpg", // 分享图标
              success: function () {
                alert("分享朋友成功");
              }, fail: function (err) {
                alert("分享朋友失败" + err);
              }
            });
          });
          //错误了会走 这里
          wx.error(function (res) {
            console.log("微信分享错误信息", res);
          });
          //分享数据，这段主要是为了在hash模式下分享出去的链接不被浏览器截取，保证完全把链接分享出去
          // var url = window.location.href.split('#')[0];
          // let shareData = {
          //     title: "移动100G流量免费领！", // 分享标题
          //     desc:"点击此链接即可免费领取 包邮到家！",
          //     link: this.urls,
          //     imgUrl: "https://blogobs.88688.team/blog/l-logo-y.jpg" // 分享图标
          // };

          // console.log("分享数据",shareData);
          // //引用
          // wexinShare(obj, shareData);
        }
        //分享给朋友
      })
      // var broser = window.navigator.userAgent.toLowerCase();
      // //通过正则表达式匹配broser 中是否含有MicroMessenger字符串
      // if (broser.match(/MicroMessenger/i) == 'micromessenger') {

      // } else {
      //     alert("请使用微信浏览器打开");
      //     return;
      // }
    },
    share(param) {
      var tempParam = {
        title: param.title,
        desc: param.desc,
        link: param.link,
        imgUrl: param.imgUrl,
        success: (res) => {
          console.log(res)
        },
        cancel: function (res) {
          console.log('分享失败', res)
        },
      }
      // //分享给朋友
      wx.onMenuShareAppMessage(tempParam)
      // //分享给朋友圈
      wx.onMenuShareTimeline(tempParam)
      // // 分享给朋友
      wx.updateAppMessageShareData(tempParam)
      wx.updateTimelineShareData(tempParam)
    },
    init() {
      this.prizes = []
      wxRequest("applyChangeSim/user/lottery/prize", { iccid: this.$store.state.iccid }, "post").then(res => {
        this.prizeNums = res.data.data.prizeNums
        this.dataList = res.data.data.list
        res.data.data.list.forEach(item => {
          var icon = {
            src: item.img,
            width: '20%',
            top: '60%'
          }
          this.prizes.push(
            //  { fonts: [{ text: item.prizeName, top: '10%' }], background: '#fff' },
            {
              fonts:
                [{ text: item.prizeName, top: '25%', fontSize: '14px', fontColor: '#947600' },
                { text: item.remark, top: '45%', fontColor: '#CFC5AE', fontSize: '10px' }],
              imgs: [icon]
            }
          )
        })

      })
    },
    linkGto() {
      this.$router.push({ name: 'winningRecord' })
    },
    changesss(data) {
      this.index = data
    },
    confirmPasswordOnDelete() {
      this.password = this.password.slice(0, this.password.length - 1);
    },

    confirmPasswordOnInput(key) {
      this.password = (this.password + key).slice(0, 6);
    },
    sunmbitFn() {
      this.confirmPasswordKeyboard = true
      this.showPasswordPanel = true
    },
    cancelChangePassword() {
      this.password = '';
      this.passwordPanelTop = 50;
      this.showPasswordPanel = false;
      this.confirmPasswordKeyboard = false
    },
    sureToRecharge() {
      var params = {
        "iccid": this.$store.state.iccid,
        "payPass": this.password, //　支付密码
        "amount": this.index　 //　购买的次数　不是金额
      }
      wxRequest("order/sysUser/wx/prize/order", params, "post").then(res => {
        if (res.data.code === '200') {
          Dialog.alert({ title: "提示", message: '兑换成功' });
          this.cancelChangePassword()
          this.init()
          this.isShow = false
        } else if (res.data.code === '404') {
          Dialog.confirm({
            title: '提示',
            width: '90%',
            showCancelButton: false,
            messageAlign: 'left',
            confirmButtonColor: '#ee0a24',
            message: `当前账户余额不足，点击确定 前往充值`
          }).then(() => {
            // this.$router.push({ name: 'balanceRecharge' })
            this.$router.replace('/newUser/recharge')
          }).catch(() => {
            // on cancel
          });
        } else {
          Toast.fail(res.data.message);
          this.cancelChangePassword()
        }
      })

    },
    // 点击抽奖按钮会触发star回调
    startCallback() {
      if (this.prizeNums > 0) {
        // 调用抽奖组件的play方法开始游戏
        this.$refs.myLucky.play()
        // 模拟调用接口异步抽奖
        setTimeout(() => {
          wxRequest("applyChangeSim/user/lottery", { iccid: this.$store.state.iccid }, "post").then(res => {
            if (res.data.code === '200') {
              var k = this.dataList.findIndex(item => item.prizeId === res.data.data.prizeId) // 通过返回的id和已有的数据的id匹配，获取返回的数据的索引值
              this.prizeNums = res.data.data.prizeNum;
              // 调用stop停止旋转并传递中奖索引
              this.$refs.myLucky.stop(k)
            } else if (res.data.code === '400') {
              Toast.fail(res.data.message);
            } else if (res.data.code === '404') {
              Dialog.confirm({
                title: '提示',
                width: '90%',
                showCancelButton: false,
                messageAlign: 'left',
                confirmButtonColor: '#ee0a24',
                message: `不是会员用户或已过期！请点击 确定 前往开通会员再来参与活动`
              }).then(() => {
                // this.$router.push({ name: 'balanceRecharge' })
                this.$router.replace('/user/userAgreement')
              }).catch(() => {
                // on cancel
              });
            }
          })
        }, 3000)
      } else {
        Toast.fail('当前无抽奖次数，请充值');
      }
    },
    // 抽奖结束会触发end回调
    endCallback(prize) {
      this.zjShow = true
      this.formData = {
        text: prize.fonts[0].text,
        smText: prize.fonts[1].text,
        imgUrl: prize.imgs[0].src,
      }
    },
  }
}
</script>

<style lang="less" scoped>
.van-popup--center.van-popup--round {
  width: 77%;
}

.btnButton {
  width: 70%;
  margin: 16px auto;
  margin-top: 20px;
  font-size: 16px;
  display: block;
  border-radius: 22px;
  background: -webkit-linear-gradient(to bottom,
      #ffd73f,
      #ff4e00);
  /* Safari 5.1-6.0 */
  background: -o-linear-gradient(to bottom,
      #ffd73f,
      #ff4e00);
  /* Opera 11.1-12.0 */
  background: -moz-linear-gradient(to bottom,
      #ffd73f,
      #ff4e00);
  /* Firefox 3.6-15 */
  background: linear-gradient(to bottom, #ffd73f, #ff4e00);
  /* 标准语法 */
  border: 1px solid #ff4e00;
  border-top-color: #ffd73f;
  border-left-color: #ffd73f;
  border-right-color: #ffd73f;
}

.body {
  background: #632FB5 url(../../assets/dzp/bg.jpg);
  background-size: 100% 100%;
  padding-top: 124px;


  .changePasswordPanel-balanceRecharge [class*=van-hairline]::after {
    border-color: #c4cedc;
  }

  .changePasswordPanel-balanceRecharge {
    padding: 10px;

    .icon-cross {
      position: absolute;
      right: 10px;
      font-size: 16px;
    }

    p {
      margin: 10px 16px 0 16px;
      line-height: 30px;
    }

    .confirmChangePassword {
      display: flex;
      justify-content: flex-end;
      margin-top: 20px;

      .confirmChangePasswordBtn {
        width: 80px;
        margin: 0 15px;
      }
    }


  }

  .opportunity {
    width: 60%;
    height: 50px;
    margin: 10px auto;
    text-align: center;
    line-height: 50px;
    background: url(../../assets/dzp/frequency.png) no-repeat center;
    background-size: 100% 100%;
    color: #fff;
    font-size: 18px;
  }

  .LuckyWheel {
    width: 370px;
    margin: 10px auto;
    background: url(../../assets/dzp/base.png) no-repeat center bottom;
    background-size: 100%;
    height: 480px;
  }

  .kh {
    width: 100%;
    text-align: center;
    font-size: 10px;
    color: #A694D1;
  }

  .btnfx {
    display: flex;
    margin-top: 20px;

    div {
      width: 50%;
      font-size: 18px;
      text-align: center;
      line-height: 80px;
      height: 80px;
      color: #fff;
      cursor: pointer;
    }

    .lefx {
      background: url('../../assets/dzp/btn1.png')no-repeat center;
      background-size: 100% 100%;
    }

    .refx {
      background: url('../../assets/dzp/btn2.png')no-repeat center;
      background-size: 100% 100%;
    }
  }

  .zjjl {
    width: 100%;
    text-align: center;
    font-size: 18px;
    margin-top: 14px;
    color: #c42fd2;
    cursor: pointer;
  }

  .msgz {
    width: 100%;
    text-align: center;
    font-size: 20px;
    margin-top: 22px;
    color: #fff;

    img {
      width: 26px;
      margin: 0 15px;
    }
  }

  .ysaf {
    margin-top: 30px;
    font-size: 12px;
    color: #fff;
    padding-left: 26px;

    p {
      padding-bottom: 14px;
    }
  }
}

.recharge {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  height: 100%;

  .r-bg {
    position: fixed;
    background: rgba(0, 0, 0, .3);
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }

  .r-content {
    width: 80%;
    height: 405px;
    background: url(../../assets/dzp/czbg.png) no-repeat center;
    background-size: 100% 100%;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;

    .select {
      color: #3A3A3A;
      font-size: 16px;
      margin-top: 125px;
      margin-left: 22px;
      margin-bottom: 13px;
    }

    .van-row {
      margin: 0 14px;

      .van-col--8 {
        height: 94px;
        padding: 7.5px;

        .colow {
          border: 1px solid #EAEAEA;
          height: 100%;
          border-radius: 6px;
          text-align: center;
          cursor: pointer;

          .price {
            height: 60%;
            font-size: 18px;
            color: #333;
            border-bottom: 1px #EAEAEA dashed;
            line-height: 2.5;
          }

          .price-num {
            line-height: 2;
            color: #8A8A8A;
          }
        }

        .active {
          border: 1px solid #FD8B2C;
          background: url(../../assets/dzp/sz.png) no-repeat right top;
          background-size: 18px;

          .price {
            color: #FD8B2C;
          }

          .price-num {
            color: #FD8B2C;
          }
        }
      }
    }

    .btnButton {
      width: 85%;
      margin: 16px auto;
      margin-top: 50px;
      font-size: 16px;
      display: block;
      border-radius: 6px;
      background: -webkit-linear-gradient(to right, #FEAC37, #FD7324);
      /* Safari 5.1-6.0 */
      background: -o-linear-gradient(to right, #FEAC37, #FD7324);
      /* Opera 11.1-12.0 */
      background: -moz-linear-gradient(to right, #FEAC37, #FD7324);
      /* Firefox 3.6-15 */
      background: linear-gradient(to right, #FEAC37, #FD7324);
      /* 标准语法 */
      border: 1px solid #FD7324;
      border-image: -webkit-linear-gradient(to right, #FEAC37, #FD7324);
      /* Safari 5.1-6.0 */
      border-image: -o-linear-gradient(to right, #FEAC37, #FD7324);
      /* Opera 11.1-12.0 */
      border-image: -moz-linear-gradient(to right, #FEAC37, #FD7324);
      /* Firefox 3.6-15 */
      border-image: linear-gradient(to right, #FEAC37, #FD7324);
      /* 标准语法 */
    }

    .zbxf {
      width: 100%;
      text-align: center;
      color: #8A8A8A;
      cursor: pointer;
      font-size: 16px;
    }
  }

  .r-content-zj {
    width: 85%;
    height: 380px;
    background: url(../../assets/dzp/zj.png) no-repeat center;
    background-size: 100% 100%;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    text-align: center;

    .title {
      color: #FD7424;
      font-size: 28px;
      width: 100%;
      text-align: center;
      margin-top: 30px;
    }

    .sm-title {
      color: #F9F9F9;
      font-size: 14px;
      margin-top: 26px;
    }

    .zj-img {
      margin-top: 60px;

      img {
        width: 70px;
      }
    }

    .btnButton {
      width: 85%;
      margin: 20px auto;
      font-size: 16px;
      display: block;
      color: #FF5E64;
      border-radius: 6px;
      background: #FFFA8E;
      border: 1px solid #FFFA8E;
    }

    .zbxf {
      width: 100%;
      text-align: center;
      color: #F9F9F9;
      cursor: pointer;
      font-size: 16px;
    }
  }
}
</style>